import { Injectable } from '@angular/core';

@Injectable()
export class DataService {
  public storage: any;
  constructor() {
  }

  getStorage() {
    return this.storage;
  }

  setStorage(storage: any) {
    this.storage = storage;
  }
}
